import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  h1: {
    "&.MuiTypography-root": {
      fontSize: "42px",
      lineHeight: "48px",
      fontWeight: 700,
    },
  },
  h2: {
    "&.MuiTypography-root": {
      fontSize: "36px",
      lineHeight: "44px",
      fontWeight: 700,
    },
  },
  h3: {
    "&.MuiTypography-root": {
      fontSize: "32px",
      lineHeight: "40px",
      fontWeight: 600,
    },
  },
  h4: {
    "&.MuiTypography-root": {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 600,
    },
  },
  h5: {
    "&.MuiTypography-root": {
      fontSize: "20px",
      lineHeight: "28px",
      fontWeight: 500,
    },
  },
  h6: {
    "&.MuiTypography-root": {
      fontSize: "18px",
      lineHeight: "28px",
      fontWeight: 500,
    },
  },
}));
